import React, { useState } from 'react';
import Footer from './components/Footer';

const contactRows = [
  {
    label: 'Email us',
    value: 'sojakanjakan@gmail.com',
    href: 'mailto:sojakanjakan@gmail.com'
  },
  {
    label: 'Call our team',
    value: '0714167283',
    href: 'tel:+94714167283'
  },
  {
    label: 'Visit HQ',
    value: 'Wayamba University of Sri Lanka',
    href: undefined
  }
];

export default function ContactPage() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitted(true);
  };

  return (
    <div className="public-page-shell">
      <main className="public-page-main">
        <section className="public-hero-panel">
          <div className="public-hero-content">
            <div>
              <p className="hero-eyebrow">Contact Us</p>
              <h1 className="public-hero-title">Support that feels personal, not transactional.</h1>
            </div>
            <p className="public-hero-copy">
              Whether you are trying to find the right tutor, list yourself as a teacher, or need help with the platform,
              the LankaTutor team is here to guide you quickly and clearly.
            </p>
            <div className="public-stat-grid">
              <article className="public-stat-card">
                <p className="public-stat-value">Fast replies</p>
                <p className="public-stat-label">Clear help for teacher onboarding, student discovery, and account support.</p>
              </article>
              <article className="public-stat-card">
                <p className="public-stat-value">Human support</p>
                <p className="public-stat-label">Talk to a real team that understands the Sri Lankan tuition ecosystem.</p>
              </article>
              <article className="public-stat-card">
                <p className="public-stat-value">Guided setup</p>
                <p className="public-stat-label">We can help teachers present their profiles better and help families search more confidently.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="contact-grid" style={{ marginTop: '1.5rem' }}>
          <div className="contact-card public-surface-card">
            <h3>Reach us directly</h3>
            <ul className="contact-list">
              {contactRows.map(row => (
                <li key={row.label}>
                  <span>{row.label}</span>
                  {row.href ? (
                    <a href={row.href} className="page-link">{row.value}</a>
                  ) : (
                    <strong>{row.value}</strong>
                  )}
                </li>
              ))}
            </ul>

            <div style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(148,163,184,0.18)' }}>
              <h3 style={{ marginBottom: '0.6rem' }}>What we can help with</h3>
              <ul className="public-inline-list">
                <li><strong>Teacher onboarding</strong><span>Support with creating a polished profile, uploading materials, and improving visibility.</span></li>
                <li><strong>Student guidance</strong><span>Help comparing teachers, understanding subject fit, and finding the right contact path.</span></li>
                <li><strong>General support</strong><span>Account recovery, platform questions, and partnership conversations.</span></li>
              </ul>
            </div>
          </div>

          <form className="contact-form public-surface-card" onSubmit={handleSubmit}>
            <h3 style={{ marginBottom: '0.35rem' }}>Send a message</h3>
            <p style={{ margin: '0 0 1rem', color: 'var(--text-muted)', lineHeight: 1.7 }}>Tell us what you need and we will point you in the right direction.</p>

            {isSubmitted && (
              <div style={{ marginBottom: '1rem', borderRadius: '1rem', border: '1px solid rgba(16,185,129,0.25)', background: 'rgba(16,185,129,0.08)', color: '#047857', padding: '0.9rem 1rem', fontSize: '0.92rem', fontWeight: 600 }}>
                Message received. We will get back to you shortly.
              </div>
            )}

            <label htmlFor="fullName">Full name</label>
            <input id="fullName" name="fullName" className="input-field" placeholder="Your name" required />

            <label htmlFor="email">Email address</label>
            <input
              id="email"
              name="email"
              type="email"
              className="input-field"
              placeholder="you@example.com"
              required
            />

            <label htmlFor="subject">Subject (Optional)</label>
            <input id="subject" name="subject" className="input-field" placeholder="e.g. Mathematics Tuition" />

            <label htmlFor="message">How can we help?</label>
            <textarea
              id="message"
              name="message"
              className="text-area"
              placeholder="Tell us what you are looking for..."
              required
            />

            <div className="form-actions">
              <button type="submit" className="btn primary">Send Message</button>
              <p className="form-note">
                Prefer email? Reach us at <a className="page-link" href="mailto:sojakanjakan@gmail.com">sojakanjakan@gmail.com</a>
              </p>
            </div>
          </form>
        </section>
      </main>
      <Footer />
    </div>
  );
}
